// utils/jwtUtils.js
import { jwtDecode } from 'jwt-decode';

export const decodeToken = (token) => {
  if (!token) {
    throw new Error('Token is required');
  }

  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
};

export const getTokenExpiration = (token) => {
  const decoded = decodeToken(token);
  return decoded?.exp ? decoded.exp * 1000 : null;
};
